import { selectServiceAreas } from '../redux/slices/commonData'
import useAppSelector from './useAppSelector'

export function useServiceAreas() {
  return useAppSelector(selectServiceAreas())
}
